<div class="header-container d-flex d-md-none d-sm-none d-lg-none d-xl-none">
  <div class="logo-container d-flex d-md-none d-sm-none d-lg-none d-xl-none">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle ">
      <i class="fa fa-bars" aria-hidden="true"></i>
    </a>

  </div>

</div>

<div class="header-container w-100">
  <div>
    <a href="#" class="logo_clientlogo" (click)="$event.preventDefault()">
      <!-- <img src="assets/images/amnex_logo.png" alt="amnex logo" /> -->
      <img [src]="base64Img"/>
    </a> </div>

  <div class="ml-auto">
    <div class="ml-auto"><div class="amnexproduct-datetimenow"><strong>{{jstoday}}</strong></div></div>
  </div>

  <!-- <div class="input-group col-md-3 ml-2 d-none d-md-flex d-sm-flex d-lg-flex  col-0 col-sm-3 col-lg-3 col-xl-3 max-width225">
    <kendo-autocomplete #autocompletePage
    class=" input-group  form-control py-2 product_borderradius product-positiontopcenterheader"
    [data]="source"
    [filterable]="true"
    [valueField]="'text'"
    (valueChange)="NavigateTo($event)"
    [(ngModel)]="selectedmenu"
    (filterChange)="handleFilter($event)"
    [placeholder]="'Search'">
  </kendo-autocomplete> -->
    <!-- <input class="form-control py-2 product_borderradius" type="search" value="search" id="searchinput"> -->
    <!-- <span class="input-group-append">
      < <button class="btn btn-outline-secondary product_innerborderradius" type="button">
        <i class="fa fa-search"></i>
      </button> 
    </span> -->
  <!-- </div> -->
  <nb-actions size="small" class="">
    <!-- <nb-action class="control-item" icon="bell-outline"></nb-action> 
    <nb-action (click)="ShowNotificationPanel()"><span class="product-notificationnumber">{{notificationCount}}</span></nb-action> -->
    <!-- <nb-action (click)="ShowNotificationPanel()" class="control-item" [ngClass]="(isBlink==true)?'blink':''" icon="bell-outline"></nb-action> -->
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <i class="arrow-icon fa fa-angle-down ml-2" aria-hidden="true"></i>
      <nb-user class="user-action-dropdown" [nbContextMenu]="userMenu" nbContextMenuTag="my-context-menu" [onlyPicture]="userPictureOnly" [name]="user" [picture]="user?.picture">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>

<!-- Kendo Dialog -->
<kendo-dialog title="Themes" *ngIf="opened"  (close)="close('cancel')" [minWidth]="300"
  [width]="300">
  <div class="w-100">
    <kendo-label text="Set GUI" class="d-block product_labelinput">
    </kendo-label>
    <nb-select [selected]="currentTheme" class="k-select w-100" (selectedChange)="changeTheme($event)" status="primary">
      <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
    </nb-select>
  </div>
  <div class="w-100">
    <kendo-label text="Set Landing Page" class="mt-2 d-block product_labelinput">
    </kendo-label>
    <kendo-dropdownlist class="w-100"
    popupAnchor [defaultItem]="{ menumappingid: null, menuName: 'Select Landing Page' }"
    [valuePrimitive]="true"
    [(ngModel)] = "selectedmenu"
    [data]="MenuList"
    textField="menuName"
    valueField="menumappingid"
    (valueChange)="ValueChangeMenu($event)">
  </kendo-dropdownlist>
  <span><i>Note : Change in landing page will be effective after re-login</i></span>
  </div>
  <div class="d-flex mt-3">
    <button kendoButton class="ml-auto" (click)="close()">Cancel</button>
    <button kendoButton class="ml-2 k-primary px-2" (click)="Save()">Save</button>
  </div>

</kendo-dialog>


<!-- Kendo Dialog Change Password-->
<kendo-dialog title="Change Password" *ngIf="isChangePassword"
  (close)="closeChangePassword('cancel')" [minWidth]="300" [width]="300">
  <form novalidate [formGroup]="editChangePasswordForm" autcomplete="off">
    <div class="form-group change-password">
      <kendo-label text="New Password" class="mt-2 d-block product_labelinput">
      </kendo-label>
      <input type="password" class="k-textbox" formControlName="password" autcomplete="off" [(ngModel)]="password"/>
      <div class="k-tooltip k-tooltip-validation d-table text-left"
        *ngIf="editChangePasswordForm.get('password').invalid && (editChangePasswordForm.get('password').touched || editChangePasswordForm.get('password').dirty)">

        <div *ngIf="editChangePasswordForm.get('password').hasError('required')">
          Please enter password </div>

        <div *ngIf="editChangePasswordForm.get('password').errors.minlength">
          Password must be at least 8 characters
        </div>
        
        <div class="error-text" *ngIf="editChangePasswordForm.get('password').hasError('passwordStrength')">
          {{editChangePasswordForm.get('password').errors['passwordStrength']}}
        </div>
      </div>
    </div>

    <div class="form-group change-password">
      <kendo-label text="Confirm Password" class="mt-2 d-block product_labelinput">
      </kendo-label>
      <input type="password" class="k-textbox" formControlName="confirmpassword" autcomplete="off"
       [(ngModel)]="confirmpassword"/>
      <div class="k-tooltip k-tooltip-validation d-table text-left"
        *ngIf="editChangePasswordForm.get('confirmpassword').invalid && 
        (editChangePasswordForm.get('confirmpassword').touched || 
        editChangePasswordForm.get('confirmpassword').dirty)">

        <div *ngIf="editChangePasswordForm.get('confirmpassword').hasError('required')">
          Please enter password </div>

        <!-- <div *ngIf="editChangePasswordForm.get('confirmpassword').errors.minlength">
          Password must be at least 8 characters
        </div> -->

        <!-- <div class="error-text" *ngIf="editChangePasswordForm.get('confirmpassword').hasError('passwordStrength')">
          {{editChangePasswordForm.get('confirmpassword').errors['passwordStrength']}}
        </div> -->
      </div>
    </div>
    <!-- <div class="d-flex mt-3">
      <button kendoButton class="ml-auto" (click)="closeChangePassword()">Cancel</button>
      <button kendoButton class="ml-2 k-primary px-2" (click) = "updatePassword()">Save</button>
    </div> -->
  </form>
  <kendo-dialog-actions>
    <button class="k-button" (click)="closeChangePassword()">Cancel</button>
    <button class="k-button k-primary" [disabled]="!editChangePasswordForm.valid" (click)="updatePassword()">Save</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- Alert And Notification Panel -->
<div class="productbg-box" *ngIf="isAlertPanelShow">
  <div class="product_innertitle d-flex align-items-center">
    <div>
      <strong>Alerts</strong>
    </div>
    <div class="ml-auto product-textmarkblue d-flex align-items-center">
      <div><span class="product-hoverunderline poi" (click)="SortNotificationData()"><strong>Sort</strong></span></div>
      <div class="ml-2"><span class="product-hoverunderline poi" (click)="DismissNotificationFromAlertPanel()">
        <strong>Dismiss All</strong></span>
      </div>
    </div>
  </div>
  <div class="product-heightdivide">
    <div *ngFor="let i of ALertPanelNotificationData; let k=index;">
      <div class="producth-notification py-1 my-1" *ngIf="notificationDisplayCount > k">
        <div class="d-flex w-100 align-items-center">
          <div class="product-textmarkgrey product-maxw180"><strong> {{i.requestname}} </strong></div>
          <div class="ml-auto">
            <a (click)="DetailNotificationFromAlertPanel(i)" class="k-button p-1">Detail</a>
            <a (click)="DismissNotificationFromAlertPanel(i, k)" class="ml-2 k-button p-1">Dismiss</a>
          </div>
        </div>
        <div class="d-flex w-100 product-textmarkgrey">
          {{i.requesteddate}}
        </div>
      </div>
    </div>
    <div *ngIf="isShowLoadMore" class="producth-notification py-1 my-1 text-center">
      <span (click)="LoadMore()" class="product-hoverunderline poi"><strong>Load More</strong></span>
    </div>
  </div>
</div>






<!-- <div><button class="k-button k-primary" (click)="RequestAccept()">Accept</button></div>
            <div><button class="k-button k-primary" (click)="RequestReject()">Reject</button></div> -->